<template>
    <div
            class="d2-layout-header-aside-group"
            :style="styleLayoutMainGroup"
            :class="{grayMode: grayActive}">
        <!-- 半透明遮罩 -->
        <div class="d2-layout-header-aside-mask"></div>
        <!-- 主体内容 -->
        <div class="d2-layout-header-aside-content" flex="dir:top">
            <!-- 顶栏 -->
            <div
                    class="d2-theme-header"
                    :style="{
          opacity: this.searchActive ? 0.5 : 1
        }"
                    flex-box="0"
                    flex>
                <!--      right-shadow-border  -->
                <div class="logo-group right-shadow-border"
                     :style="{width: asideCollapse ? asideWidthCollapse : asideWidth}"
                     flex-box="0"
                     style="height: 101px;z-index: 1;background: white;padding-top: 20px;"
                     @click="handleToggleAside">
                    <!--          <img v-if="asideCollapse" :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/icon-only.png`">-->
                    <img v-if="asideCollapse" :src="`${$baseUrl}image/theme/reer/logo/icon-only.png`">
                    <img v-else :src="`${$baseUrl}image/theme/reer/logo/all.png`">
                    <!--          <img v-else :src="`${$baseUrl}image/theme/${themeActiveSetting.name}/logo/all.png`">-->
                </div>

                <div class="reer_custom_header_right" flex-box="1" style="height: 101px;"
                     :style="{backgroundImage:'url(' + `${$baseUrl}image/theme/reer/header_bg.png`+ ')', backgroundRepeat:'no-repeat',backgroundSize: '100% 100%'}">

                    <!--          <div class="toggle-aside-btn" @click="handleToggleAside" flex-box="0">-->
                    <!--            <d2-icon name="bars"/> 隐藏掉三横线的点击缩小-->
                    <!--          </div>-->
                    <d2-menu-header flex-box="1"/>
                    <!-- 顶栏右侧 -->
                    <div class="d2-header-right" flex-box="0">
                        <!-- 如果你只想在开发环境显示这个按钮请添加 v-if="$env === 'development'" -->
                        <!--            让我看一下-->

                        <d2-header-search @click="handleSearchClick"/>

                        <!--            日志-->
                        <d2-header-log v-if="$env === 'development'"/>

                        <!--          <d2-header-fullscreen/>-->
                        <!--          <d2-header-theme/>-->
                        <!--          <d2-header-size/>-->
                        <!--          <d2-header-locales/>-->
                        <d2-header-user/>



                    </div>

                </div>

            </div>
            <!-- 下面 主体 -->
            <div class="d2-theme-container layout_reer_custom" flex-box="1" flex>
                <!-- 主体 侧边栏 -->
                <div
                        flex-box="0"
                        ref="aside"
                        class="d2-theme-container-aside right-shadow-border "
                        style="margin-top: 41px;margin-right:0px;z-index:2;background: white;"
                        :style="{
            width: asideCollapse ? asideWidthCollapse : asideWidth,
            opacity: this.searchActive ? 0.5 : 1
          }">
                    <d2-menu-side/>
                </div>

                <!-- 主体 -->
                <div class="d2-theme-container-main  " flex-box="1" flex>
                    <!-- 搜索 -->
                    <transition name="fade-scale">
                        <div v-if="searchActive" class="d2-theme-container-main-layer" flex>
                            <d2-panel-search
                                    ref="panelSearch"
                                    @close="searchPanelClose"/>
                        </div>
                    </transition>
                    <!-- 内容 -->
                    <transition name="fade-scale">
                        <div v-if="!searchActive" class="d2-theme-container-main-layer" flex="dir:top">
                            <!-- tab 也就是点开的标签页..-->

                            <div class="d2-theme-container-main-header" flex-box="0">
                                <d2-tabs/>
                            </div>
                            <!-- 页面 -->
                            <div class="d2-theme-container-main-body" flex-box="1">
                                <transition :name="transitionActive ? 'fade-transverse' : ''">
                                    <keep-alive :include="keepAlive">
                                        <router-view/>
                                    </keep-alive>
                                </transition>
                            </div>
                        </div>
                    </transition>
                </div>
                <view-file-bar style="z-index: 3000;" v-if="viewFilePageOption.show"/>

            </div>
        </div>

      <div class="browserCheck" v-if="needAlertBrowser" >

        <div  class="barAlert" >
                  推荐使用谷歌浏览器,安全稳定,<a class="aDownload" href="https://www.google.cn/chrome/" target="_blank">点击下载</a><span  @click="needAlertBrowser=false" style="cursor:pointer;position: absolute;right: 0px;margin-top: 4px;" class="el-icon-close">&nbsp;</span>
        </div>

      </div>
    </div>
</template>

<script>
    import d2MenuSide from './components/menu-side'
    import d2MenuHeader from './components/menu-header'
    import d2Tabs from './components/tabs'
    import d2HeaderFullscreen from './components/header-fullscreen'
    import d2HeaderLocales from './components/header-locales'
    import d2HeaderSearch from './components/header-search'
    import d2HeaderSize from './components/header-size'
    import d2HeaderTheme from './components/header-theme'
    import d2HeaderUser from './components/header-user'
    import d2HeaderLog from './components/header-log'
    import {mapState, mapGetters, mapActions} from 'vuex'
    import mixinSearch from './mixins/search'
    import viewFileBar from '../../components/common/viewFileBar.vue'

    export default {
        name: 'd2-layout-header-aside',
        mixins: [
            mixinSearch
        ],
        components: {
            d2MenuSide,
            d2MenuHeader,
            d2Tabs,
            d2HeaderFullscreen,
            d2HeaderLocales,
            d2HeaderSearch,
            d2HeaderSize,
            d2HeaderTheme,
            d2HeaderUser,
            d2HeaderLog,
            viewFileBar
        },
        data() {
            return {
                // [侧边栏宽度] 正常状态
                asideWidth: '160px',
                // [侧边栏宽度] 折叠状态
                asideWidthCollapse: '65px',
                needAlertBrowser:false,
            }
        },
        computed: {
            ...mapState('d2admin', {
                keepAlive: state => state.page.keepAlive,
                grayActive: state => state.gray.active,
                transitionActive: state => state.transition.active,
                asideCollapse: state => state.menu.asideCollapse
            }),

            ...mapGetters('d2admin', {
                themeActiveSetting: 'theme/activeSetting'
            }),
            /**
             * @description 最外层容器的背景图片样式
             */
            styleLayoutMainGroup() {
                return {
                    ...this.themeActiveSetting.backgroundImage ? {
                        backgroundImage: `url('${this.$baseUrl}${this.themeActiveSetting.backgroundImage}')`
                    } : {}
                }
            },
            viewFilePageOption() {
                return this.$store.state.fileExtra;
            }

        },
        created(){
          // 页面初始化
          this.needAlertBrowser=this.isShowChromeTip();
          setTimeout(()=>{
            this.needAlertBrowser=false;
            // 无论如何，30秒后消失
          },30000);
        },
        methods: {
            ...mapActions('d2admin/menu', [
                'asideCollapseToggle'
            ]),
            isShowChromeTip() {
              // @ts-ignore
              const USER_AGENT = navigator.userAgent.toLowerCase();
              const isChrome = /.*(chrome)\/([\w.]+).*/
              return !isChrome.test(USER_AGENT)
            },
            /**
             * 接收点击切换侧边栏的按钮
             */
            handleToggleAside() {
                this.asideCollapseToggle()
            }
        }
    }
</script>

<style lang="scss">

  .browserCheck{
    position: fixed;top:0px;left:50%;background: transparent;
    .barAlert{
      position:relative;font-size:14px;text-align:center;width:330px;padding-bottom: 5px;padding-top: 5px;background: white;margin-left: -170px;
    }
    .aDownload{
      color:dodgerblue;text-decoration: underline;
    }
  }
    /*.reer_custom_header_right{*/
    /*  background: -webkit-linear-gradient(left bottom,#00b8f0,#a9fff8);*/
    /*  background: -o-linear-gradient(left bottom,#00b8f0,#a9fff8);*/
    /*  background: -moz-linear-gradient(left bottom,#00b8f0,#a9fff8);*/
    /*  background: linear-gradient(left bottom,#00b8f0,#a9fff8);*/
    /*}*/
    .right-shadow-border {
        box-shadow: 10px 5px 9px -8px #d7d7d7;
    }

    //让主内容横向能填满屏幕
    .layout_reer_custom .d2-container-full {
        width: 100%;
    }

    .layout_reer_custom .d2-theme-container-aside .el-menu .el-submenu__title:hover {
        color: #47bee2 !important;
    }

    .layout_reer_custom .d2-theme-container-aside .el-menu .el-submenu__title:hover i {
        color: #47bee2 !important;

    }


    .layout_reer_custom .d2-theme-container-aside .el-menu .el-menu-item.is-active i {
        color: #47bee2 !important;
    }

    .layout_reer_custom .d2-theme-container-aside .el-menu .el-menu-item.is-active {
        color: #47bee2 !important;
        background-color: #e4f4fa !important;
    }

    //当前菜单栏处于激活状态时，背景色改变
    .layout_reer_custom .d2-theme-container-aside .el-submenu.is-active {
        /*border: 1px solid red!important;*/
        /*background-color: #f1f8fb!important;*/
        background-color: #e4f4fa !important;
    }

    // 注册主题
    @import '~@/assets/style/theme/register.scss';
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/layout.vue"
}
</vue-filename-injector>
